import { Product } from 'src/app/interfaces';

export class GetLandinSections {
    static readonly type = '[Landing] get all sections';
}
export class GetAppSettings {
    static readonly type = '[Landing] get application settings';
}
export class UpdateFavoritesNewIn {
    static readonly type = '[Landing] Update favorites New In';
    constructor(public payload: Product) {}
}

export class UpdateFavoritesProducts {
    static readonly type = '[Landing] Update favorites Products';
    constructor(public payload: Product) {}
}
